import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Inmigrantes hispanohablantes en EE. UU. que tienen su cita de ciudadanía cerca.', 'Personas que trabajan y tienen poco tiempo para estudiar.', 'Solicitantes que sienten que su inglés es limitado y temen no entender al oficial.', 'Quienes quieren una guía directa, sin rellenos y fácil de leer.'];
  const notForYou = ['Personas que buscan asesoría legal o abogados (esto es material educativo).', 'Quienes no están dispuestos a dedicar al menos 15 minutos al día a practicar en voz alta.'];
  return <section className="w-full bg-[#F7F5F0]" data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-lg shadow-lg" data-id="element-16">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-6" data-id="element-17">
              ✅ Esto Es Para Ti Si...
            </h2>
            <ul className="space-y-4" data-id="element-18">
              {forYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-19">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-20" />
                  <span className="text-gray-700" data-id="element-21">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-lg shadow-lg" data-id="element-22">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-6" data-id="element-23">
              ❌ Esto NO Es Para Ti Si...
            </h2>
            <ul className="space-y-4" data-id="element-24">
              {notForYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-25">
                  <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" data-id="element-26" />
                  <span className="text-gray-700" data-id="element-27">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}